import React from "react";

export const CopySvg = ({ width, height, color }) => (
  <svg
    width={width ?? "25"}
    height={height ?? "24"}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0132 12.9V17.1C16.0132 20.6 14.6132 22 11.1132 22H6.91318C3.41318 22 2.01318 20.6 2.01318 17.1V12.9C2.01318 9.4 3.41318 8 6.91318 8H11.1132C14.6132 8 16.0132 9.4 16.0132 12.9Z"
      fill={color ?? window?.settings?.primary_color ?? "#1DBD6B"}
    />
    <path
      d="M17.1132 2H12.9132C9.83011 2 8.38417 3.09409 8.08293 5.73901C8.01991 6.29235 8.47819 6.75 9.0351 6.75H11.1132C15.3132 6.75 17.2632 8.7 17.2632 12.9V14.9781C17.2632 15.535 17.7208 15.9933 18.2742 15.9303C20.9191 15.629 22.0132 14.1831 22.0132 11.1V6.9C22.0132 3.4 20.6132 2 17.1132 2Z"
      fill={color ?? window?.settings?.primary_color ?? "#1DBD6B"}
    />
  </svg>
);

export const CopyOutlineSvg = ({ width, height, color }) => (
  <svg
    width={width ?? "14"}
    height={height ?? "14"}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4.18555"
      y="0.999939"
      width="9.31579"
      height="9.31579"
      rx="0.973685"
      fill="white"
      stroke="#1AAA60"
    />
    <rect
      x="0.5"
      y="4.68427"
      width="9.31579"
      height="9.31579"
      rx="0.973685"
      fill="white"
      stroke="#1AAA60"
    />{" "}
  </svg>
);
